// ADDED
import React, { useState } from "react";
import { Input, TextArea } from "../../../../common/Input";
import { Select } from "../../../../common/Select";
import { Button, GeneralMessage } from "../../../../common/APICommon";
import { ConfirmationModal } from "../../../../common/Modal";
import { EmployeePickerField } from "../../../../common/selectComponents/EmployeePicker";
import OffsetLeavePickerField from "../../../../common/selectComponents/OffsetLeavePicker";
import OffsetOvertimePickerField from "../../../../common/selectComponents/OffsetOvertimePicker";

const OffsetRequestModule = ({
  user, userAccess, formData, handleInputChange,
  handleSelectEmployee, submitRequest, showMessage, message, isSuccess, loading
}) => {
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [errorState, setErrorState] = useState(false);

  const validate = (e) => {
    e.preventDefault();
    if (!formData.employeeId || !formData.reason) { setErrorState(true); return; }
    if (formData.type === "Overtime" && (!formData.referenceDate || !formData.date || !formData.hours)) { setErrorState(true); return; }
    if (formData.type === "Leave" && (!formData.reference || !formData.dateFrom || !formData.dateTo)) { setErrorState(true); return; }

    setErrorState(false);
    setIsConfirmOpen(true);
  };

  return (
    <div className="p-6">
      <form onSubmit={validate} className="grid grid-cols-1 md:grid-cols-2 gap-6 bg-gray-50 p-6 rounded-lg border">
        <EmployeePickerField
          label="Employee" employeePersonalInformationId={formData.employeeId}
          displayValue={formData.employeeName} onSelect={handleSelectEmployee}
          disabled={userAccess.description !== "Admin"} // Example restriction
        />

        <Select
          label="Type" value={formData.type} isRequired
          onChange={(e) => handleInputChange('type', e.target.value)}
          options={[{ value: 'Overtime', label: 'Overtime' }, { value: 'Leave', label: 'Leave' }]}
        />

        {formData.type === "Overtime" ? (
          <>
            <OffsetOvertimePickerField
              employeeId={formData.employeeId} value={formData.referenceDate}
              onSelect={(val) => { handleInputChange('referenceDate', val); handleInputChange('hours', val.remainingValue); }}
              error={errorState && !formData.referenceDate}
            />
            <Input label="Date (To Use)" type="date" value={formData.date} onChange={(e) => handleInputChange('date', e.target.value)} isRequired />
            <Input label="Hours" type="number" value={formData.hours} onChange={(e) => handleInputChange('hours', e.target.value)} isRequired />
          </>
        ) : (
          <>
            <OffsetLeavePickerField
              employeeId={formData.employeeId} value={formData.reference}
              onSelect={(val) => { handleInputChange('reference', val); handleInputChange('days', val.remainingValue); }}
              error={errorState && !formData.reference}
            />
            <div className="grid grid-cols-2 gap-2">
              <Input label="Date From" type="date" value={formData.dateFrom} onChange={(e) => handleInputChange('dateFrom', e.target.value)} isRequired />
              <Input label="Date To" type="date" value={formData.dateTo} onChange={(e) => handleInputChange('dateTo', e.target.value)} isRequired />
            </div>
            <Input label="Days" type="number" value={formData.days} onChange={(e) => handleInputChange('days', e.target.value)} isRequired />
          </>
        )}

        <div className="md:col-span-2">
          <TextArea label="Reason" placeholder="Enter your reason here..." value={formData.reason} onChange={(e) => handleInputChange('reason', e.target.value)} isRequired rows={3} />
        </div>

        <div className="md:col-span-2 flex justify-end mt-4">
          <Button name="Send Request" className="bg-blue-600 text-white px-10 py-2 font-bold" type="submit" />
        </div>
      </form>

      <GeneralMessage form={showMessage} message={message} isSuccess={isSuccess} />
      <ConfirmationModal
        visible={isConfirmOpen} onClose={() => setIsConfirmOpen(false)}
        onConfirm={async () => { const ok = await submitRequest(); if (ok) setIsConfirmOpen(false); }}
        title="Confirm Offset Submission" isLoading={loading}
      />
    </div>
  );
};

export default OffsetRequestModule;